// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__3YYUf","question":"Question_question__3HJuU","description":"Question_description__3MStw"};